/**
 * Parse JSON, returning null on failure.
 */
export var safeParseJSON = function safeParseJSON(data) {
  try {
    return JSON.parse(data);
  } catch (e) {// No JSON data could be parsed, do nothing
  }

  return null;
};